function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 20L27.5306 13H7.93878L5 33H18.5",
  stroke: "black",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 17C24 -3 12 -3 12 17",
  stroke: "black",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36 28.2317C36 33.3657 31.6628 38 26.5 38C20.8352 38 17 33.4167 17 28.2317C17 23.1924 21.2433 19 26.5 19C31.7567 19 36 23.1924 36 28.2317Z",
  stroke: "black",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "number",
  d: "M23.1914 28.1328L23.7998 23.0469H29.6172V24.8379H25.6729L25.4473 26.8135C25.6113 26.7178 25.8255 26.6335 26.0898 26.5605C26.3587 26.4876 26.6208 26.4512 26.876 26.4512C27.8649 26.4512 28.6237 26.7451 29.1523 27.333C29.6855 27.9163 29.9521 28.7367 29.9521 29.7939C29.9521 30.432 29.8086 31.0107 29.5215 31.5303C29.2389 32.0452 28.8402 32.4417 28.3252 32.7197C27.8102 32.9977 27.2018 33.1367 26.5 33.1367C25.8757 33.1367 25.29 33.0091 24.7432 32.7539C24.1963 32.4941 23.7679 32.141 23.458 31.6943C23.1481 31.2432 22.9954 30.735 23 30.1699H25.3105C25.3333 30.5345 25.4495 30.8239 25.6592 31.0381C25.8688 31.2523 26.1445 31.3594 26.4863 31.3594C27.2611 31.3594 27.6484 30.7852 27.6484 29.6367C27.6484 28.5749 27.1745 28.0439 26.2266 28.0439C25.6888 28.0439 25.2878 28.2171 25.0234 28.5635L23.1914 28.1328Z",
  fill: "black"
});

function SvgCart5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart5);
export default __webpack_public_path__ + "static/media/cart5.180fd3e4.svg";
export { ForwardRef as ReactComponent };